export { default } from './AppRedirectionPopup';
export { getPlatformType } from './helpers';
